import { PropertyType } from '../../hooks/use-dots-property'
import { getAPIUrl } from '../API'

export type GetTrackingNumbersFromPropertyProps = {
  erfNo?: string
  townshipName?: string
  schemeName?: string
  unitNo?: string
  officeCode?: string
  portionNumber?: string
  holdingName?: string
  propertyType: PropertyType | null
  registrationDivision?: string
} | null

export interface GetTrackingNumbersFromPropertyResponse {
  trackingNumber: number
  entityName: string
  officeCode: string
}

export const getTrackingNumbersFromProperty = async (
  values: GetTrackingNumbersFromPropertyProps,
) => {
  if (!values)
    throw new Error('Arguments undefined. Can not determine a property type.')
  const {
    erfNo,
    schemeName,
    unitNo,
    townshipName,
    portionNumber,
    officeCode,
    propertyType,
    holdingName,
    registrationDivision,
  } = values

  if (propertyType === PropertyType.Erf)
    return await getTrackingNumbersFromErf({
      erfNumber: erfNo || '',
      townshipName: townshipName || '',
      officeCode: officeCode || '',
      portionNumber: portionNumber || '',
    })
  if (propertyType === PropertyType.SectionalTitleUnit)
    return await getTrackingNumbersFromSectionalTitle({
      schemeName: schemeName || '',
      unitNo: unitNo || '',
      officeCode: officeCode || '',
    })
  if (propertyType === PropertyType.AgriculturalHolding)
    return await getTrackingNumbersFromAgriculturalHolding({
      agriculturalHoldingName: holdingName || '',
      agriculturalHoldingNumber: erfNo || '',
      officeCode: officeCode || '',
      portionNumber: portionNumber || '',
    })
  if (propertyType === PropertyType.Farm)
    return await getTrackingNumbersFromFarm({
      farmNumber: erfNo || '',
      registrationDivision: registrationDivision || '',
      officeCode: officeCode || '',
      portionNumber: portionNumber || '',
    })
  throw new Error('Not enough arguments. Could not determine a property type.')
}

export type GetTrackingNumbersFromErfProps = {
  erfNumber: string
  townshipName: string
  officeCode: string
  portionNumber: string
}

export const getTrackingNumbersFromErf = async (
  props: GetTrackingNumbersFromErfProps,
) => {
  const result = await fetch(getAPIUrl() + '/Deeds/ERFDotsQuery', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify(props),
  })

  if (result.ok) {
    const data = await result.json()
    return data.data
  }
}

export type GetTrackingNumbersFromSectionalTitleProps = {
  schemeName: string
  unitNo: string
  officeCode: string
}

export const getTrackingNumbersFromSectionalTitle = async (
  props: GetTrackingNumbersFromSectionalTitleProps,
) => {
  const result = await fetch(getAPIUrl() + '/Deeds/SectionalTitleDotsQuery', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify(props),
  })

  if (result.ok) {
    const data = await result.json()
    return data.data
  }
}

export type GetTrackingNumbersFromAgriculturalHoldingProps = {
  agriculturalHoldingNumber: string
  agriculturalHoldingName: string
  portionNumber: string
  officeCode: string
}

export const getTrackingNumbersFromAgriculturalHolding = async (
  props: GetTrackingNumbersFromAgriculturalHoldingProps,
) => {
  const result = await fetch(
    getAPIUrl() + '/Deeds/AgriculturalHoldingDotsQuery',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
      },
      body: JSON.stringify(props),
    },
  )

  if (result.ok) {
    const data = await result.json()
    return data.data
  }
}

export type GetTrackingNumbersFromFarmProps = {
  farmNumber: string
  registrationDivision: string
  portionNumber: string
  officeCode: string
}

export const getTrackingNumbersFromFarm = async (
  props: GetTrackingNumbersFromFarmProps,
) => {
  const result = await fetch(getAPIUrl() + '/Deeds/FarmDotsQuery', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
    },
    body: JSON.stringify(props),
  })

  if (result.ok) {
    const data = await result.json()
    return data.data
  }
}
